import PropTypes from 'prop-types';

import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import _ from 'lodash';

import { bootstrapApp } from '../lib/actions';
import pressMenuHide from '../lib/press-menu-hide';

import PressArchivePage from '../components/press-page/press-archive-page';

class PressNewsRoute extends Component {
  componentDidMount() {
    pressMenuHide();
  }

  render() {
    const { pressArticles, dispatch } = this.props;
    const data = _.get(pressArticles, 'headlines', {
      featured: [],
      archive: [],
    });
    const header = 'News';
    const title = 'Making headlines';
    const subtitle =
      'People are talking. Check out breaking news, the latest stories and top headlines about NerdWallet.';
    const subtitleMobile =
      'People are talking. Check out breaking news, the latest stories and top headlines about NerdWallet.';

    return (
      <div>
        <DocumentTitle title="News | NerdWallet" />
        <PressArchivePage
          {...{
            header,
            title,
            subtitle,
            subtitleMobile,
            data,
            dispatch,
            archiveType: 'external',
          }}
        />
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressNewsRoute.displayName = 'PressNewsRoute';
PressNewsRoute.analyticsName = 'news_page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
PressNewsRoute.propTypes = {
  pressArticles: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

PressNewsRoute.bootstrap = function bootstrap(store, req, res, callback) {
  store.dispatch(
    bootstrapApp({
      name: 'headlines',
      callback,
    })
  );
};

export default connect((state) => state)(PressNewsRoute);
